import type { Checklist } from '../types';

export const checklists: Checklist[] = [
  {
    "id": "全日",
    "title": "保全全日勤務",
    "role": [
      "day",
      "night",
      "committee"
    ],
    "items": [
      {
        "id": "全日_001",
        "text": "上哨前須熟悉智生活操作，加入 Line 管委會群組",
        "type": "check",
        "required": true,
        "hint": "管委會群組"
      },
      {
        "id": "全日_002",
        "text": "值勤期間須閱讀 Line 群組事項(尤其是機動班要往前回捲,了解社區動態, 被住戶詢問時才不會一問三不知)",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_003",
        "text": "為掌握人員進出, 值勤時不可睡覺, 社區監控器會紀錄, 住戶經過, 要從座位站起來打招呼, 比方說(您好,我是新來的警衛,請問是幾樓之幾住戶,我看看有沒有您的包裹)",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_004",
        "text": "交接上哨時，填寫工作日誌，更換黃色名牌，以便離開警衛室時，他人可透過名牌聯絡",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_005",
        "text": "離開警衛室時，門需上鎖1",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_006",
        "text": "為避免讓住戶領包裹時吸到致癌的二手煙, 如果在警衛室門外抽菸時須關門, 不可到頂樓抽菸",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_007",
        "text": "當日發現異常須紀錄在值班日誌上，照相到 Line 群組，處理完畢回報到 Line 群組",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_008",
        "text": "若安排維修或消防機電檢測，盡可能以正常班上班日，以免機動班不了解情況",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_009",
        "text": "若有社區維修檢測人員到場，應撥空陪同，拍照紀錄，詢問若該設備故障時應急處理措施",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_010",
        "text": "平時應監控螢幕了解各螢幕監控地點，必要時協助手動控制允許車輛進出（確認是否住戶、訪客或社區工程維修車）",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_011",
        "text": "警衛前車道為本社區私有地，不可停車，須管制驅離, 為鄰里和諧, 可讓鄰居暫停接送, 但不含商家客人",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_012",
        "text": "社區中庭並無合法停車位，放置橘色禁止停車牌(上面有相關公告), 用重物壓住避免被風吹倒, 僅允許訪客暫停，須登記每次僅能暫停30分鐘，於擋風玻璃處放置牌子標示車主聯絡方式",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_013",
        "text": "社區B1,B2未劃車位處不可停車，僅允許已申請裝修者暫停，不可擋住消防通道，於擋風玻璃處放置牌子標示車主聯絡方式",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_014",
        "text": "外送食物人員，統一放置於1F大門進入後左側桌子，並應標示幾樓之幾，保全人員不可幫外送人員開電梯門，以避免物品遺失爭議",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_015",
        "text": "快遞大型物品在警衛室放不下時，暫放置聯誼廳，門需上溑避免遺失",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_016",
        "text": "保全人員於上班前在手機安裝智生活管理版，郵件包裹/寄放物品/退貨都必須以電子方式登記，並在物品上貼上智生活給的編號，住戶領取時，除智生活結單外，也須在紙本上簽名",
        "type": "check",
        "required": true,
        "hint": "智生活管理版"
      },
      {
        "id": "全日_017",
        "text": "智生活故障時，以紙本先行，編號暫時以1000往後編, 系統恢復之後須補登及更正編號",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_018",
        "text": "社區信箱感應開鎖容易故障,請住戶開鎖後不要上鎖",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_019",
        "text": "信箱旁側門永遠維持關閉",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_020",
        "text": "車道大鐵門固定不關(車道 大門): 因為會造成門禁監控系統脫離, 正常時應於平日 06:30-21:00 手動開啟(下雨天避免車道輪子打滑空轉要預先開啟, 因常故障因此開啟時間和B1升降門不一致)",
        "type": "check",
        "required": true,
        "hint": "車道 大門"
      },
      {
        "id": "全日_021",
        "text": "手動開關B1車道門(車道 地下室), 平日上下班時段 06:30-09:30 及 18:00-21:00 開啟",
        "type": "check",
        "required": true,
        "hint": "車道 地下室"
      },
      {
        "id": "全日_022",
        "text": "手動開關室內燈光: 17:00-22:00開啟(開啟一樓大廳燈光, 每層樓客梯左邊兩個開關, 打開左邊的一個, 標示綠色圓點的開關為常開夜間不關)",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_023",
        "text": "自動外觀景觀燈於18:30-21:00開啟, 若故障時, 要手動操作Ds2000開關",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_024",
        "text": "自動灑水系統每天於??:??-??:??開啟, 若故障時且沒下雨要手動開關",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_025",
        "text": "交接下哨時，與下一班清點智生活包裹數及已知異常現象",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_026",
        "text": "基本素養:了解每個鑰匙(幾把)及開關,每本手冊功能(幾本),每個攝影鏡頭位置(幾個)",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_027",
        "text": "熟悉社區軟體操作: Line, 手機智生活管理版, 網頁智生活管理版, 電腦中央監控系統(Ba-9800), 門禁管制系統(Ds-2000)",
        "type": "check",
        "required": true
      }
    ]
  },
  {
    "id": "日班",
    "title": "保全日班勤務",
    "role": [
      "day",
      "committee"
    ],
    "items": [
      {
        "id": "日班_001",
        "text": "06:30 平日手動開啟B1車道門(車道 地下室), 假日關",
        "type": "check",
        "required": true,
        "hint": "車道 地下室"
      },
      {
        "id": "日班_002",
        "text": "07:00-07:30 到信箱核對智生活未領包裹戶別是否一致，拿掉已經領走的吊牌",
        "type": "check",
        "required": true
      },
      {
        "id": "日班_003",
        "text": "07:30-08:30 平日站哨, 假日不用",
        "type": "check",
        "required": true
      },
      {
        "id": "日班_004",
        "text": "??:??-???:?? 沒下雨時，開啟前澆花系統約30分鐘, 檢視1樓及樓頂自動灑水系統運作(共?處)，失效時手動澆水",
        "type": "check",
        "required": true
      },
      {
        "id": "日班_005",
        "text": "08:30-09:30 社區收運垃圾車到達協助開門讓其進入",
        "type": "check",
        "required": true
      },
      {
        "id": "日班_006",
        "text": "09:00-14:00 收發信件包裹（智生活及對講機通知,若有住戶不願對講機通知要標註在包裹領用紙本首頁）",
        "type": "check",
        "required": true
      },
      {
        "id": "日班_007",
        "text": "09:30 關閉B1車道門",
        "type": "check",
        "required": true
      },
      {
        "id": "日班_008",
        "text": "14:00-15:00 派發一般信件至住戶信箱以及若有未領包裹掛牌, 目前社區停止使用電子信箱鎖, 不要推太前面將信箱上鎖",
        "type": "check",
        "required": true
      },
      {
        "id": "日班_009",
        "text": "17:00-18:00 巡邏、開啟夜間燈光(開啟一樓大廳燈光, 每層樓客梯左邊兩個開關, 打開左邊的一個)、巡視各設備庫房狀況",
        "type": "check",
        "required": true
      },
      {
        "id": "日班_010",
        "text": "18:00 平日開啟B1車道門,假日關",
        "type": "check",
        "required": true
      },
      {
        "id": "日班_011",
        "text": "18:30 交接下哨",
        "type": "check",
        "required": true
      }
    ]
  },
  {
    "id": "夜班",
    "title": "保全夜班勤務",
    "role": [
      "night",
      "committee"
    ],
    "items": [
      {
        "id": "夜班_001",
        "text": "18:30 上哨",
        "type": "check",
        "required": true
      },
      {
        "id": "夜班_002",
        "text": "19:00-20:00 平日站哨(假日不站,但住戶經過仍須站起來打招呼)",
        "type": "check",
        "required": true
      },
      {
        "id": "夜班_003",
        "text": "20:00-21:00 再次用對講機通知住戶領取包裹、掛號信,若有住戶不願對講機通知要標註在包裹領用紙本首頁",
        "type": "check",
        "required": true
      },
      {
        "id": "夜班_004",
        "text": "21:00 關閉B1車道門",
        "type": "check",
        "required": true
      },
      {
        "id": "夜班_005",
        "text": "22:00-22:30 一樓大廳燈光關閉",
        "type": "check",
        "required": true
      },
      {
        "id": "夜班_006",
        "text": "01:00-01:30 巡邏(含門口左側停車場共用牆避免被噴漆)、巡視各設備庫房狀況, B2廢水池水位檢視",
        "type": "check",
        "required": true
      },
      {
        "id": "夜班_007",
        "text": "06:30 交接下哨",
        "type": "check",
        "required": true
      }
    ]
  }
];
